import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  // @Input() spinner = environment.rondeivu_spinner_style;
  @Input() message: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
